import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { PostAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card } from 'reactstrap';
import PostContainer from './postContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
import { ConvertUtcToLocal, checkPermissions } from 'hooks';
import { Link } from 'react-router-dom';
import { MdVideoLibrary, MdImage } from "react-icons/md";
import PopupWindow from 'components/ModalPopup';
import ReactHlsPlayer from "react-hls-player";

const Searches = (props) => {

    const [open, setOpen] = React.useState(false);

    const [media, setMedia] = React.useState({ type: '', source: '' });

    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        if (props.userId) {
            filters['userId'] = props.userId;
        }
        props.getSearches(filters)
    }, [props.pagination, props.order, props.userId]);

    React.useEffect(() => {
        props.getTotalCount(props.totalRecord);
    }, [props.postList])

    const Icon = (row) => {
        const Icon = (row.rowData[5] === 'raw_video') ? MdVideoLibrary : MdImage;
        return <Icon onClick={(e) => showMedia(row.rowData)} className="mediaIcon" />
    }
    const customBody = (value, tableMeta, updateValue) => {
        
        return (tableMeta.columnData.name === 'image') ?
            <div style={{ height: '100px', width: '100px' }}>
                <Icon rowData={tableMeta.rowData} />
                <Avatar style={{ border: '1px solid', opacity: '0.5' }} src={(tableMeta.rowData[11]) ? tableMeta.rowData[11] : (value) ? value : noImage} />
            </div> : (tableMeta.columnData.name === 'created_at' || tableMeta.columnData.name === 'updated_at') ? ConvertUtcToLocal(value, 'MM-DD-YYYY HH:mm:ss')
                : (tableMeta.columnData.name === 'username') ? (checkPermissions(props.loginData, 'user_profile')) ? <Link to={`/user-profile/${tableMeta.rowData[1]}`}>{value}</Link> : value
                    : (tableMeta.columnData.name === 'website' && value) ? <a target={'_blank'} href={`${value}`}>{value}</a>
                        : value;
    }

    const showMedia = (rowData) => {
        setMedia({ type: rowData[5], source: (rowData[5] !=='raw_video' && rowData[11])?rowData[11]:rowData[2] })
        setOpen(true);
    }
    const columns = () => {
        let columnsList = [
            {
                name: "id",
                label: "S.No.",
            },
            {
                name: "userId",
                label: "User Id",
            },
            {
                name: "image",
                label: "Image",
            },
            {
                name: "search_term",
                label: "Search Term",
            },
            {
                name: "website",
                label: "Website",
            },
            {
                name: "type",
                label: "Type",
            },
            {
                name: "username",
                label: "Username",
            },
            {
                name: "title",
                label: "Title",
            },
            {
                name: "description",
                label: "Description",
            },
            {
                name: "deleted_at",
                label: "Deleted",
            },
            {
                name: "created_at",
                label: "Created At",
            },
            {
                name: "updated_at",
                label: "Updated At",
            },
            {
                name: "thumb_url",
                label: "thumb_url",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: customBody,
                    display: (column.name === 'id' || column.name === 'userId' || column.name === 'thumb_url') ? false : true,
                    setCellProps: () => ({
                        style: (column.name === 'search_term' || column.name === 'website' || column.name === 'description' || column.name === 'title') ? { maxWidth: "150px" } : { width: 'auto' }
                    }),
                }
            }
        })
    }
    return (<>
        <Card className="mb-3">
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.postList} columns={columns()} options={props.options} />
            }
        </Card>
        <PopupWindow
            hideButton={true}
            handlePopup={() => setOpen(false)}
            openWindow={open}
            title={''}
        >
            <div style={{ textAlign: 'center' }}>
                {(media.type === 'raw_video') ?
                    <ReactHlsPlayer
                        src={media.source}
                        autoPlay={true}
                        controls={true}
                        width="460"
                        hlsConfig={{
                            maxLoadingDelay: 4,
                            minAutoBitrate: 0,
                            lowLatencyMode: true,
                          }}

                    />
                    : <img alt="Search Journey Media" src={media.source} width="460" height="320" onError={({ currentTarget }) => {
                        currentTarget.onerror = null; 
                        currentTarget.src = noImage;
                        
                    }} />
                }


            </div>

        </PopupWindow>
    </>
    );
}

const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    postList: (state.post && state.post.searches && state.post.searches.posts) ? state.post.searches.posts : [],
    totalRecord: (state.post && state.post.searches && state.post.searches.total_posts) ? state.post.searches.total_posts : 0,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getSearches: (payload) => dispatch(PostAction.getSearches(payload)),
});
export default PostContainer(connect(mapStateToProps, mapDispatchToProps)(Searches), { defaultOrderBy: 'updated_at' });